import React, { useEffect, useState } from 'react';
import { FilterContainer, PageTitle } from 'resources/styles/TableStyle';
import { createGlobalStyle } from 'styled-components';
import Button from 'components/input/NewButton';
import SearchBox from 'components/input/SearchBox';
import { Row } from 'saladsoft-primitive';
import { observer } from 'mobx-react-lite';
import { useStoreWrapper } from 'stores/StoreHelper';
import SaladToggleButton from 'components/input/SaladToggleButton';
import { AdminUserFilterType } from 'types/CommonTypes';
import TableHeader from '../tables/TableHeader';

const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }
`;

const AdminUserFilter = observer(
  ({
    onclick,
    onClickAdd,
  }: {
    onclick: (search: AdminUserFilterType) => void;
    onClickAdd: () => void;
  }) => {
    const { userFilterStore } = useStoreWrapper();

    const items = [
      { value: 'all', label: '전체' },
      { value: 'active', label: '활성화' },
      { value: 'withdrawn', label: '비활성화' },
    ];

    const [defaultIndex, setDefaultIndex] = useState(() => {
      const savedType = userFilterStore.adminUserConditions?.type;
      if (savedType) {
        const index = items.findIndex((item) => item.value === savedType);
        return index >= 0 ? index : 0;
      }
      return 0;
    });

    const handleChangeType = (value: string) => {
      if (value === null) {
        return;
      }

      setDefaultIndex(items.findIndex((item) => item.value === value));

      userFilterStore.setAdminUserFilter({
        ...userFilterStore.adminUserConditions,
        type: value as AdminUserFilterType['type'],
      });

      onclick({
        ...userFilterStore.adminUserConditions,
        type: value as AdminUserFilterType['type'],
      });
    };

    return (
      <div style={{ marginTop: 10 }}>
        <GlobalInputStyle />
        <Row justifyContent="space-between" width="100%">
          <PageTitle>관리자 목록</PageTitle>

          <FilterContainer>
            <SaladToggleButton
              defaultIndex={defaultIndex}
              items={items}
              onChange={handleChangeType}
            />
            <SearchBox paramKey="searchKeyword" placeholder="회원명 또는 이메일" />
          </FilterContainer>
          <div style={{ minWidth: 160 }}>
            <Button
              onClick={() => {
                onClickAdd();
              }}
            >
              관리자 계정 추가
            </Button>
          </div>
        </Row>
      </div>
    );
  },
);

export default AdminUserFilter;
